module.exports = __webpack_public_path__ + "static/img/free.8d3a1c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/portal/free.png
// module id = 167
// module chunks = 18